import {
  changeTimeScale,
  changeMinDate,
  changeMaxDate,
} from '../store/actions/date_range_actions';

export default class StoreProxy {
  constructor(store) {
    this.store = store;
  }

  dispatch(action) {
    switch (action.type) {
      case 'CHANGE_TIME_SCALE':
        return this.store.dispatch(changeTimeScale(action.payload.timeScale));
      case 'CHANGE_MIN_DATE':
        return this.store.dispatch(changeMinDate(action.payload.date));
      case 'CHANGE_MAX_DATE':
        return this.store.dispatch(changeMaxDate(action.payload.date));
      default:
        return this.store.dispatch(action);
    }
  }

  getState() {
    return this.store.getState();
  }
}
